// extracted by mini-css-extract-plugin
module.exports = {"lease-toggles":"LeaseToggles_lease-toggles__3VOS-","types-switch":"LeaseToggles_types-switch__3lP7i","switch-button":"LeaseToggles_switch-button__19Pzn"};